import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import moment from "moment";

//import utils
import { LocaleContext } from "../../../../routing/LangRouter";
import { formatPersianDate } from "../../../../utils/date";

//import general components
import BaseRating from "../../../common/base-rating/base-rating";

//import images and icons
import Icon from "../../../common/base-icon/icon";
import noImage from "../../../../assets/imgs/no-image.png";
import { Airplane, Location, Star1 } from "iconsax-react";

//import styles
import "./my-tour-item.scss";
import BASE_URL from "../../../../constants/baseUrls";

function MyTourItem({ information, tourItem }) {
    //general variables
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    //transfer types
    const transferType = [
        { id: 1, name: t("air"), icon: <Airplane color="var(--dark-color)" variant="Bold" style={{ transform: "rotate(-90deg)"}} /> },
        { id: 2, name: t("ground"), icon: <Icon name="TrainIcon" /> },
        { id: 3, name: t("rail"), icon: <Icon name="BusIcon" /> },
    ];

    //format date in Persian format
    const formatDate = date => {
        return formatPersianDate(date, {
            day: "numeric",
            month: "long",
            year: undefined,
            weekday: undefined,
        });
    };


    return (
        <Grid className="my-tour-item" container item xs={12} rowGap={1} columnGap={3}>
            <Grid className="my-tour-item__tour-image" container item xs={12} md={2} direction="column" justifyContent="space-between">
                <img src={`${BASE_URL}${tourItem?.extra_images?.[0]?.image}` || noImage} />
            </Grid>

            <Grid
                container
                item
                md={3}
                direction={{ xs: "row", md: "column" }}
                rowGap={1}
                columnGap={1}
                alignItems={{ xs: "center", md: "flex-start" }}
            >
                <span>{tourItem?.name}</span>

                <span className="tour-item__city-name">
                    <Location color="var(--dark-color)" variant="Bold" />
                    {["fa", "ar"].includes(locale) ? tourItem?.destination_city?.name : tourItem?.destination_city?.english_name}
                </span>

                <span className="tour-item__tour-type">{tourItem.prices?.[0]?.services}</span>
            </Grid>

            <Grid container item md={3} direction={{ xs: "row", md: "column" }} rowGap={2}>
                <span className="tour-item__tour-transportation point">
                    {transferType?.[tourItem?.transfer_type - 1]?.icon}
                    {transferType?.[tourItem?.transfer_type - 1]?.name}
                </span>
                <Grid className="tour-item__hotel-name point" container item xs="auto" columnGap={1} alignItems="center">
                    {tourItem.accommodations.length > 1 ? (
                        `${tourItem.accommodations.length} ${t("hotel")}`
                    ) : (
                        <>
                            {tourItem.accommodations?.[0]?.accommodation?.name}
                            <BaseRating
                                value={tourItem.accommodations?.[0]?.accommodation.star}
                                icon={Star1}
                                emptyIcon={Star1}
                                color="var(--golden-color)"
                                size="20"
                                readOnly={true}
                            />
                        </>
                    )}
                </Grid>
                <span className="tour-item__tour-date">
                    {["en", "ar"].includes(locale) ? (
                        <>
                            {moment(tourItem.start_date).format("ddd D MMM")} - {moment(tourItem.end_date).format("ddd D MMM")}
                        </>
                    ) : (
                        <>
                            {formatDate(tourItem.start_date)} - {formatDate(tourItem.end_date)}
                        </>
                    )}
                </span>
            </Grid>

            <Grid container item md={3} rowGap={2}>
                <Grid className="my-tour-item__count" container item xs={12} columnGap={2} justifyContent="center">
                    <span>{t("numberOfPeople")}:</span>
                    <span>
                        {information?.adult_count} {t("adult")}
                    </span>
                    <span>{!!information?.child_count && information?.child_count + " " + `${t("child")}`}</span>
                </Grid>

                <Grid className="my-tour-item__status" container item xs={12} columnGap={2} justifyContent="center">
                    <span>{t("status")}:</span>
                    <span>
                        {information.status === 1
                            ? t("requestSubmitted")
                            : information.status === 2
                            ? t("underReview")
                            : information.status === 3
                            ? t("finalized")
                            : ""}
                    </span>
                </Grid>

                <Grid
                    className={`my-tour-item__payment ${information?.paid ? "paid" : ""} `}
                    container
                    item
                    xs={12}
                    columnGap={2}
                    justifyContent="center"
                >
                    <span>{t("paymentStatus")}:</span>
                    {information?.paid ? <span>{t("paid")}</span> : <span>{t("unpaid")}</span>}
                </Grid>
            </Grid>
        </Grid>
    );
}

export default MyTourItem;
